import { render, staticRenderFns } from "./GameView.vue?vue&type=template&id=b3c82f58&scoped=true"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"
import style0 from "./GameView.vue?vue&type=style&index=0&id=b3c82f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c82f58",
  null
  
)

export default component.exports